import { defineStore } from 'pinia'
import api from '@/services/api'
import { useAuthStore } from './auth'


export const useParceriasStore = defineStore('parcerias', {
  state: () => ({
    authStore: useAuthStore(),
    parcerias: []
  }),
  actions: {
    async get() {
        
        const result = await api.get('/parcerias', {
            headers: {
              Authorization: `Bearer ${this.authStore.access_token}`
            }
        })
        this.parcerias = result.data
    },
    async add(novaParceria) {
        
      novaParceria.percentual_desconto = parseFloat(novaParceria.percentual_desconto)
      const result = await api.post('/parcerias', novaParceria, {
            headers: {
              Authorization: `Bearer ${this.authStore.access_token}`
            }
        })
        
        if(result.data.id)
        {  
          return {status : true}
        }else{
          return {status : false, message : result.data.message}
        }

    },
    async update(parceria){

      parceria.percentual_desconto = parseFloat(parceria.percentual_desconto)
      const result = await api.put(`/parcerias/${parceria.id}`, parceria, {
            headers: {
              Authorization: `Bearer ${this.authStore.access_token}`
            }
        })
        
        if(result.data.id)
        {  
          return {status : true}
        }else{
          return {status : false, message : result.data.message}
        }

    },
    async delete(parceria){

      const result = await api.delete(`/parcerias/${parceria.id}`, {
            headers: {
              Authorization: `Bearer ${this.authStore.access_token}`
            }
        })
        
        if(result.data.id)
        {  
          return {status : true}
        }else{
          return {status : false, message : result.data.message}
        }

    } 
  }
})